// Operations workspace data layer — typed wrappers over existing endpoints.
import { apiRequest } from '@/lib/supabase';

export interface FleetTotals {
  instances: number;
  healthy: number;
  stale: number;
  platform_licenses?: number;
  active_orgs?: number;
  backed_up?: number;
}
export interface FleetOverview {
  totals: FleetTotals;
  version_distribution: Array<{ version: string; count: number }>;
  health_breakdown?: Record<string, number>;
  vuln_totals?: Record<string, number>;
  last_backup_at?: string | null;
}

export interface VulnSummary { critical?: number; high?: number; medium?: number; low?: number; scanned_at?: string }
export interface FleetInstance {
  instance_id: string;
  hostname?: string | null;
  product_version?: string | null;
  last_seen_at?: string | null;
  active?: boolean;
  health_status?: string | null;
  vuln_summary?: VulnSummary | null;
}

export interface OpsJob {
  id: string;
  instance_id: string;
  op_key: string;
  status: 'pending' | 'claimed' | 'done' | 'failed';
  enqueued_at: string;
  reported_at: string | null;
}

export interface ValidationDay { date: string; validation_count: number; }

export const getFleet = () => apiRequest<FleetOverview>('/fleet');
export const getInstances = () => apiRequest<FleetInstance[]>('/fleet/instances');
export const getJobs = () => apiRequest<OpsJob[]>('/operations/jobs');
export const getValidations = (days = 7) => apiRequest<ValidationDay[]>(`/analytics/validations?days=${days}`);

export function sumVulns(instances: FleetInstance[]): { critical: number; high: number; medium: number; low: number } {
  const t = { critical: 0, high: 0, medium: 0, low: 0 };
  for (const i of instances) {
    const vs = i.vuln_summary || {};
    t.critical += Number(vs.critical || 0);
    t.high += Number(vs.high || 0);
    t.medium += Number(vs.medium || 0);
    t.low += Number(vs.low || 0);
  }
  return t;
}
